(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[891],{

/***/ "BP2b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Train", function() { return Train; });
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cxan");
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HbGN");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("ERkP");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_2__);


var __jsx = react__WEBPACK_IMPORTED_MODULE_2___default.a.createElement;

var Train = function Train(_ref) {
  var xRef = _ref.xRef,
      props = Object(_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])(_ref, ["xRef"]);

  return __jsx("svg", Object(_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"])({
    viewBox: "0 0 30 30"
  }, props, {
    ref: xRef
  }), __jsx("path", {
    fillRule: "evenodd",
    d: "M22.4 19.7H4a1 1 0 0 1 0-2h18.4a2.7 2.7 0 0 0 2.2-4h-6.5a3.3 3.3 0 0 1-3.2-3.3V7H4a1 1 0 0 1 0-2h11.9c3 0 5.8 1.4 7.6 3.8l2.5 3.4c.7.8 1 1.8 1 2.8 0 2.6-2 4.7-4.6 4.7ZM16.9 7v3.3c0 .7.5 1.3 1.2 1.3h5L22 10a7.7 7.7 0 0 0-5-3ZM4 12.7a1 1 0 0 0 0 2h5.8c1 0 1.8-.6 2.3-1.6l1-2.2c.2-.5.2-1.1-.2-1.6-.3-.5-.8-.8-1.4-.8H4a1 1 0 0 0 0 2h3l-1 2.2H4Zm5.1-2.2h2l-.9 1.8c0 .2-.2.3-.4.3H8.3l.8-2Zm4 12.8a1 1 0 0 0-.4.7c0 .5.5 1 1 1h2.6a1 1 0 0 0 1-1.3 1 1 0 0 0-.4-.4h4.3a1 1 0 0 0-.3.7c0 .5.5 1 1 1h2.6c.5 0 1-.5 1-1a1 1 0 0 0-.4-.7h.9a1 1 0 0 0 0-2H4a1 1 0 0 0 0 2h.9a1 1 0 0 0-.4.7c0 .5.5 1 1 1h2.6c.5 0 1-.5 1-1a1 1 0 0 0-.3-.7H13Z",
    clipRule: "evenodd"
  }));
};

/***/ })

}]);